/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
// import PropTypes from 'prop-types'
import { getGlobalParams } from 'config/config'
// import { mergeBy } from 'utils/merge'

import RiskLevel from '../../../atoms/RiskLevel'
import MorningStar from '../../../atoms/MorningStar'
import Pagination from '../../../molecules/Pagination'
import FundsList from '../../../templates/FundsList'

import rule from './rule'
import hkRawJson from '../../../../test/hong-kong/input_en.json'
import './style.scss'

const HKFundList = () => {
  const necessaryElements = {
    MorningStar,
    RiskLevel,
    Pagination
  }

  const [data, setData] = useState()

  useEffect(() => {
    // const { terms } = getGlobalParams()
    // const wholeData = mergeBy(hkRawJson, rule, terms)
    // console.log(`Angelo Log ~ file: index.jsx ~ line 28 ~ useEffect ~ wholeData`, wholeData)
    // setData(wholeData)
  }, [])

  return (
    <React.Fragment>
      <FundsList
        {...{
          id: 'hk-funds-list',
          necessaryElements,
          tableData: data
        }}
      />
    </React.Fragment>
  )
}

// FundList.propTypes = {}

// FundList.defaultProps = {}

export default HKFundList
